import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { FlexCenter } from '../../../styles/stylesStyled';
import { Subtitle, Title } from './WithdrawStyled';
import { useTranslation } from 'react-i18next';
import { ErrorToast } from '../../../components';
import { Button } from '../../../styles/GlobalComponents';
import { WithdrawSteps } from '../Portfolio.types';
import { createUserWallet } from '../../../slices/wallets-slice';

interface AddBankAccountProps {
  setStep: Dispatch<SetStateAction<WithdrawSteps>>;
}

export const AddBankAccount = ({ setStep }: AddBankAccountProps) => {
  const { t } = useTranslation('earnings');
  const dispatch = useDispatch();
  const [label, setLabel] = useState('');
  const [address, setAddress] = useState('');

  return (
    <div>
      <FlexCenter style={{ flexDirection: 'column' }}>
        <Title>{t('withdraw_part.add_bank_account.title')}</Title>
        <Subtitle style={{ textAlign: 'center' }}>
          {t('withdraw_part.add_bank_account.subtitle')}
        </Subtitle>

        <InputBackOffice
          placeholder={t('withdraw_part.add_bank_account.placeholderLabel')}
          value={label}
          onChange={(e: string) => setLabel(e)}
        />

        <InputBackOffice
          placeholder={t('withdraw_part.add_bank_account.placeholder')}
          value={address}
          onChange={(e: string) => setAddress(e.replace(/\s+/g, ''))}
        />

        <Button
          onClick={() => {
            if (!address) {
              ErrorToast(
                t('withdraw_part.add_bank_account.err_address_required')
              );
            } else {
              dispatch(
                createUserWallet({
                  address,
                  setAddress,
                  setStep,

                  label,
                  setLabel
                })
              );

              // setIsOpen2(false);
            }
          }}
          mt='30'
          maxWidth='200px'>
          {t('withdraw_part.add_bank_account.add')}
        </Button>
      </FlexCenter>
    </div>
  );
};
